import React from 'react';
import { TTabProps, TTabsProps } from '../isr';

const Tabs = ({ label, onClick, isActive, showLoaderUi, index, id }: TTabProps) => {
    const isUiLoading = showLoaderUi && index === 2;
    return (
        <div id={id} className={`${isUiLoading ? 'disabled' : ''} tw-flex tw-justify-center tw-items-center tw-p-2 ${!isUiLoading ? 'tw-cursor-pointer' : ''} tw-border-b-2 tw-gap-2 tw-transition-all tw-duration-500 tw-ease-in-out ${
            isActive ? 'tw-border-[#0747A6]' : isUiLoading ? '' : 'tw-border-transparent hover:tw-border-[#0747A6]'}`} onClick={onClick}>
            <span className={`tw-font-medium tw-text-sm ${isUiLoading ? 'tw-text-[#DFE0E6]' : isActive ? 'tw-text-[#0747A6]' : ''}`}>{label}</span>
        </div>
    );
};

const ISRTabs = ({id, tabLabels, activeTab, onTabClick, showLoaderUi }: TTabsProps) => {
    return (
        <div id={id} className="tw-flex tw-gap-10">
            {tabLabels.map((label, index) => (
                <Tabs 
                    id={`${id}-tab-${label.toLowerCase().replace(/\s+/g, '-')}`}
                    key={index} 
                    label={label} 
                    onClick={() => {
                        if(showLoaderUi && index === 2) {
                            return;
                        }
                        onTabClick(index);
                    }} 
                    isActive={index === activeTab} 
                    showLoaderUi={showLoaderUi} 
                    index={index}
                />
            ))}
        </div>
    );
};

export default ISRTabs;